import { Layers, Users, ClipboardCheck, Handshake, LineChart, Globe2 } from "lucide-react";
import { useSeo } from "../lib/seo";
import { PartnerLanding } from "../components/site/PartnerLanding";

const CFG = {
  key: "advertisers", eyebrow: "For Advertisers", cta: "Launch Your Campaign", defaultType: "Advertiser",
  lines: ["Grow with campaigns", "that pay on results."],
  intro: "Reach new customers through quality traffic partners, choose the model that suits your goals, and pay for the outcomes that matter to your business.",
  featuresEyebrow: "Campaign solutions", featuresTitle: "Everything you need to acquire customers at scale.",
  featuresText: "From strategy to optimisation, we manage the moving parts of performance campaigns.",
  features: [
    { icon: Layers, title: "Campaign solutions", text: "Structured campaigns across affiliate, media buying and influencer channels, aligned to one set of KPIs." },
    { icon: Users, title: "User acquisition", text: "Bring in app users who install, register and engage, with targeting by geo, device and audience." },
    { icon: ClipboardCheck, title: "Lead generation", text: "CPL campaigns built around your qualification criteria and consent requirements." },
    { icon: Handshake, title: "Publisher partnerships", text: "Access to publishers and traffic partners selected for relevance to your offer and markets." },
    { icon: LineChart, title: "Campaign optimisation", text: "Ongoing review of sources, creatives and payouts to improve efficiency over time." },
    { icon: Globe2, title: "International reach", text: "Campaigns for advertisers targeting India, the UK, the USA, Singapore and other markets." },
  ],
  modelsTitle: "Flexible pricing models: CPI, CPA and CPL.",
  modelsText: "Pick the model that matches your funnel, or combine them in one campaign.",
  models: [
    { code: "CPI", name: "Cost Per Install", text: "Pay when a user installs your app. Ideal for growing mobile user bases." },
    { code: "CPA", name: "Cost Per Action", text: "Pay for defined actions such as sign-ups, deposits, purchases or subscriptions." },
    { code: "CPL", name: "Cost Per Lead", text: "Pay for qualified enquiries that meet the criteria you set." },
    { code: "CPS", name: "Cost Per Sale", text: "Pay a fixed amount or commission when a sale is completed." },
  ],
  stepsEyebrow: "How it works", stepsTitle: "From brief to optimised campaign.",
  steps: [
    ["Share your goals", "Tell us your product, markets, KPIs and budget."],
    ["Plan the campaign", "We recommend models, payouts, channels and partners."],
    ["Launch with partners", "Campaigns go live with agreed tracking and traffic rules."],
    ["Optimise and scale", "We refine sources and scale what performs."],
  ],
  formEyebrow: "Business enquiry", formTitle: "Tell us about your campaign.",
  formText: "Share a few details and our partnerships team will respond with next steps.",
  formPoints: ["No obligation consultation", "Tailored model and payout recommendations", "Clear terms before anything goes live"],
};

export default function Advertisers() {
  useSeo("Advertisers", "Launch CPI, CPA and CPL campaigns with AppTarget. User acquisition, lead generation and publisher partnerships for advertisers worldwide.", "/advertisers");
  return <PartnerLanding cfg={CFG} />;
}
